





















import SimpleMap from '../../core/components/SimpleMap.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';

@Component({
    components: {
        Loading,
        SimpleMap
    }
})
export default class ModalMapPatchPolicy extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() geoJson: any;
    loadingMap: boolean = false;

    @Emit()
    closeModal() {}

    @Emit()
    selectedRanchsFromMap(items) {
        return items;
    }

    mounted() {
        let self = this;
        setTimeout(() => {
            self.mapPatchPolicy.addGeoJson(self.geoJson);
        }, 200);
    }

    setSelectedRanchsFromMap(items) {
       this.selectedRanchsFromMap(items);
    }

    ranchsToExclude(feature) {
        this.$emit('ranch-to-exclude', feature);
    }

    get mapPatchPolicy(): HTMLFormElement {
        return this.$refs.mapPatchPolicy as HTMLFormElement;
    }
}
